import { http } from '@/shared/https';
import { IReviewInternalServices } from './review.internal.types';
import { Summary, ISummaryData } from '@/entities';
import { ValidationMessage, IValidationMessage } from '@/entities/common';
import { Utilities as utils} from '@/shared/utilities';

export class ReviewInternalService implements IReviewInternalServices {
    getReviewData(id: number) {
        // return {};
        return http.get(`api/ReviewInternal/${id}`).then((resp: any) => {
            return resp.data;
        });
    }
    getReviewDataByApplication(id: number, entity: string) {
        return http.get(`api/ReviewInternal/Application/${entity}/${id}`)
            .then((resp: any) => {
                if(resp.status >= 200 && resp.status <= 300) {
                    return resp.data;
                }
            }).catch(e => {
                return null;
            });
    }
    /** get due diligence saved data */
    getDueDiligenceData(id: number) {
        return http.get(`api/ReviewInternal/DueDiligence/${id}`).then((resp: any) => {
            return resp.data;
        });
    }
    /** get budget saved data */
    getBudgetData(id: number) {
        return http.get(`api/ReviewInternal/Budget/${id}`).then((resp: any) => {
            return resp.data;
        });
    }
    getReviewTemplate(id: number) {
        return http.get(`api/ReviewInternal/GetTemplate/${id}`).then((resp: any) => {
            if (resp && resp.data && resp.data.Result === 'OK') {
                return resp.data.Templates.reduce((obj: any, tmpl: any) => {
                    obj[tmpl.Key] = tmpl.Value;
                    return obj;
                }, {});
            } else {
                console.log(resp.data.Message);
                return {};
            }
        });
    }
    listProposal() {
        return http.get(`/api/ReviewInternal/List`).then((resp: any) => {
            if (resp.data && resp.data.Items) {
              return resp.data.Items;
            } else {
              return [];
            }
          });
    }
    getFilter() {
        http.get(`api/ReviewInternal/GetFilter`).then((resp: any) => {
            return resp.data.Result;
        });
    }
    listReviews(e: any) {
        return http.get(`/api/ReviewInternal?${e}`).then((resp: any) => {
            return resp;
          
        });
    }
    /** method to save */
    saveReviewData(review: any): any {
        return http.post(`api/ReviewInternal`, review)
        .then((resp: any) => {
            return resp.data;
        });
    }

    /** Submit review data */
    submitReviewData(id: number, context: string, review: any, entity: string): any {
        return http.put(`api/ReviewInternal/submit/${entity}/${id}/${context}`, review)
        .then((resp: any) => {
            return resp.data;
        })
    }
    /** method to update the review */
    updateReviewData(id: number, review: any, entity: string): any {
        return http.put(`api/ReviewInternal/${entity}/${id}`, review)
            .then((resp: any) => {
                return resp.data;
            })
    }
    /** method to update the budget review */
    updateBudgetReview(id: number, review: any, entity: string): any {
        return http.put(`api/ReviewInternal/Budget/${entity}/${id}`, review)
            .then((resp: any) => {
                return resp.data;
            })
    }

    /** method to calculate summary of dd assessment */
    dueDiligenceSummary(template: any, data: any): any {
        let appSummary: Summary = new Summary({} as ISummaryData);
        let validations: Array<ValidationMessage> = new Array<ValidationMessage>();

        if(template && template.properties) {
            const sections = template.properties;
            Object.keys(sections).forEach(key => {
                if (sections[key] && sections[key].properties) {
                    const firstLevel = sections[key].properties;
                    Object.keys(firstLevel).forEach(item => {
                        if (firstLevel[item] && firstLevel[item].properties) {
                            const secLevel = firstLevel[item].properties;
                            Object.keys(secLevel).forEach(itm => {
                                if(secLevel[itm] && secLevel[itm]['x-display'] && secLevel[itm]['x-display'] === "rating-table") {
                                    this.analyzeData(secLevel, itm, data, appSummary, validations, key, firstLevel[item]);
                                } else {
                                    if(secLevel[itm].properties) { // nested rating controls
                                        const thirdLevel = secLevel[itm].properties;
                                        Object.keys(thirdLevel).forEach(x => {
                                            if(thirdLevel[x] && thirdLevel[x]['x-display'] && thirdLevel[x]['x-display'] === "rating-table") {
                                                this.analyzeData(thirdLevel, x, data, appSummary, validations, key, secLevel[itm]);
                                            }
                                        });
                                    } else if(secLevel[itm].type === "string") { // yes/no question
                                        this.analyzeData(secLevel, itm, data, appSummary, validations, key, firstLevel[item]);
                                    }
                                }
                            });
                        }
                    });
                }
            });
        }
        
        return {appSummary, validations};
    }

    analyzeData(prop: any, key: string, data: any, summary: Summary, validations: Array<ValidationMessage>, subSection: string, parent: any) {
        if (prop[key]['x-display'] === "string") { // yes/no question
            summary.propsCount += 1;
            if (data[key]) {
                summary.filledProps += 1;
            } else {
                validations.push({
                    SectionKey: 'dueDiligence',
                    SubSectionKey: subSection,
                    ItemKey: key,
                    Message: `${parent.title} >> ${prop[key].title} is required`
                })
            }
        } else if (prop[key]['x-display'] === "rating-table") { // rating question
            summary.propsCount += 1;
            if (data[key] && data[key].score != null && data[key].score != undefined) {
                summary.filledProps += 1;
            } else {
                validations.push({
                    SectionKey: 'dueDiligence',
                    SubSectionKey: subSection,
                    ItemKey: key,
                    Message: `${parent.title} >> ${prop[key].title} is required`
                })
            }
        }
    }

    /** method to calculate summary of budget assessment */
    budgetSummary(template: any, data: any): any {
        let appSummary: Summary = new Summary({} as ISummaryData);
        let validations: Array<ValidationMessage> = new Array<ValidationMessage>();

        if(template && template.properties) {
            const sections = template.properties;
            Object.keys(sections).forEach(key => {
                if (sections[key] && sections[key].properties) {
                    const firstLevel = sections[key].properties;
                    Object.keys(firstLevel).forEach(item => {
                        if (firstLevel[item] && firstLevel[item].properties) {
                            const secLevel = firstLevel[item].properties;
                            Object.keys(secLevel).forEach(itm => {
                                if (secLevel[itm]['x-display']==='radio') {
                                    appSummary.propsCount += 1;
                                    if (data[item] && data[item][itm] != undefined && data[item][itm]) {
                                        appSummary.filledProps += 1;
                                    } else {
                                        validations.push({
                                            SectionKey: 'budget',
                                            SubSectionKey: key,
                                            ItemKey: itm,
                                            Message: `${firstLevel[item].title} >> ${secLevel[itm].title} is required`
                                        })
                                    }
                                }
                            });
                        }
                    });
                }
            });
        }
        // for conclusion validation
        appSummary.propsCount += 1;
        if(data['conclusion'] && data['conclusion'] != undefined) {
            appSummary.filledProps += 1;
        } else {
            validations.push({
                SectionKey: 'budget',
                SubSectionKey: '',
                ItemKey: '',
                Message: `Conclusion is required`
            })
        }

        return {appSummary, validations};
    }

    /** get review summary by application id */
    reviewSummary(id: number, entity: string) {
        return http.get(`api/ReviewInternal/Summary/${entity}/${id}`)
        .then((resp: any) => {
            if(resp.status >= 200 && resp.status <= 300) {
                return resp.data;
            }
        })
        .catch(e => {
            return e.response;
        });
    }

    /** method to rollback the review - IUCN Admin should be able to return a review to a reviewer when needed */
    rollbackReview(id: any, type: any, reason: any): any {
        return http.put(`api/ReviewInternal/RollbackReview/${id}/${type}/${reason}`, type, reason).then((resp: any) => {
                return resp.data;
        });
    }
}